import client from '../utils/client'
import { gql } from '@apollo/client'

import { MutationHandlerError } from '../utils/errors'

const CREATE_RESTAURANT_FROM_LISTING = gql`
	mutation CreateRestaurantFromListing($slug: String!) {
		createRestaurantFromListing(slug: $slug) {
			success
			restaurantId
			created
		}
	}
`

// Legt Restaurant und Firma aus dem Eintrag der Erhebung an; created ist false, wenn es den Slug
// schon gab, restaurantId ist dann das vorhandene Restaurant.
const createRestaurantFromListing = async ({
	slug,
}: {
	slug: string
}): Promise<
	| { success: true; errors: null; restaurantId: string; created: boolean }
	| { success: false; errors: MutationHandlerError }
> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: CREATE_RESTAURANT_FROM_LISTING,
			variables: { slug },
			errorPolicy: 'all',
			// Das neue Restaurant steht gleich in der Auswahl der Restaurant-Ansicht.
			refetchQueries: ['CurrentUser'],
			awaitRefetchQueries: true,
		})

		return errors
			? { success: false, errors }
			: {
					success: true,
					errors: null,
					restaurantId: data.createRestaurantFromListing.restaurantId,
					created: data.createRestaurantFromListing.created,
			  }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default createRestaurantFromListing
